var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal-dialog", {
    attrs: {
      id: _vm.popinId,
      "modal-button-label": "Fermer",
      "action-label": "Ouvrir",
      "modal-title": _vm.title,
      "alert-html-content": _vm.alertMessage,
    },
    scopedSlots: _vm._u([
      {
        key: "modalBody",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "d-flex flex-wrap flex-md-nowrap my-1" },
              [
                _vm.visual
                  ? [
                      _c("div", { staticClass: "flex-fill me-1 order-0" }, [
                        _c("img", {
                          attrs: { src: _vm.visual.url, alt: _vm.visual.alt },
                        }),
                      ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex-fill mt-1 mt-md-0 me-md-1 order-2 order-md-1",
                  },
                  [
                    _vm._l(_vm.sections, function (section) {
                      return [
                        _c("h5", {
                          staticClass: "lead mb-1 pb-0",
                          domProps: { innerHTML: _vm._s(section.title) },
                        }),
                        _vm._v(" "),
                        section.icon
                          ? _c("div", { staticClass: "col-12" }, [
                              _c("span", {
                                staticClass:
                                  "icon h1 align-self-center text-primary3",
                                class: section.icon,
                              }),
                              _vm._v(" "),
                              _c("p", {
                                staticClass: "ms-1",
                                domProps: {
                                  innerHTML: _vm._s(section.paragraph),
                                },
                              }),
                            ])
                          : _c("p", {
                              staticClass: "m-0",
                              domProps: {
                                innerHTML: _vm._s(section.paragraph),
                              },
                            }),
                      ]
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex-fill-end order-1 order-md-2" },
                  [
                    _c("Price", {
                      attrs: { price: _vm.price, "show-by-month": true },
                    }),
                  ],
                  1
                ),
              ],
              2
            ),
            _vm._v(" "),
            _vm.mentions
              ? _c("p", {
                  staticClass: "font-size-12",
                  domProps: { innerHTML: _vm._s(_vm.mentions) },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }